export function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

export function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.interpolator(domain); break;
    default: this.interpolator(interpolator).domain(domain); break;
  }
  return this;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/src/init.js
// module id = ./node_modules/d3-scale/src/init.js
// module chunks = 54